import { api } from './api';

export interface UserProfile {
  readonly userId: string;
  readonly email: string;
  readonly name: string;
  readonly createdAt: string;
  readonly updatedAt: string;
}

export interface UpdateProfilePayload {
  readonly name: string;
}

export const profileApi = {
  get: async (): Promise<UserProfile> => {
    const result = await api.get<UserProfile>('/profile');
    if (!result.data) {
      throw new Error('Profile not found');
    }
    return result.data;
  },

  update: async (payload: UpdateProfilePayload): Promise<UserProfile> => {
    const result = await api.put<UserProfile>('/profile', payload);
    if (!result.data) {
      throw new Error('Failed to update profile');
    }
    return result.data;
  },

  deleteAccount: async (): Promise<void> => {
    await api.delete('/profile');
  },
};
